import { Modal } from "./ui/Modal";

import { useClientStoriesModal } from "../hooks/useClientStoriesModal";
import { clientStories } from "../data/client-stories";

export const ClientStoriesModal = () => {
  const { title, onClose } = useClientStoriesModal();

  const activeStory = clientStories.find((story) => story.title === title);

  if (!activeStory || activeStory.title === "--") return null;

  return (
    <Modal
      isOpen={!!title && title !== "--"}
      onClose={onClose}
      className="max-w-[1222px] fixed inset-0 p-[46px] bg-[#06101F] border border-[#06101F]"
    >
      <iframe
        src={activeStory.src}
        allowFullScreen
        loading="lazy"
        title={activeStory.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        className="w-full aspect-video rounded-2xl md:rounded-[40px] mb-6"
      ></iframe>

      <h1 className="text-xl font-semibold text-white mb-2">
        {activeStory.title}
      </h1>
      <p className="text-white">{activeStory.description}</p>
    </Modal>
  );
};
